/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import CtLEDs from './CtLEDs';
import './CtData.css';
import { Table } from 'react-bootstrap';
//import ModalConfirmacion from '../Comandos/ModalConfirmacion';
//import { Modal } from 'react-bootstrap';

function CtData(props) {

    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const { childToParent, code, ct } = props;
    var [CT, setCT] = useState([]);
    const [htmlINVS, setHtmlINVS] = useState(<></>);
    var [listaInv, setListaInv] = useState('');
    var [htmlBotonesINV, setHtmlBotonesINV] = useState(<></>);
    var [deviceINV] = useState(2);
    //var [enviarLista, setEnviarLista] = useState('');
    //var [enviarDevice, setEnviarDevice] = useState();
    //var [comandoEnviado, setComandoEnviado] = useState('');
    //const [abrirModal, setAbrirModal] = useState(false);

    /*function childToParentModal() {
        setAbrirModal(false)
    }*/

    let number = 0;
    useEffect(() => {
        fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/CTInverterRelation?idSolarFarm=" + idParque + "&idCT=" + ct, { method: 'GET', credentials: 'include' })
            .then(async (dataCT) => { setCT(await dataCT.json()); })
            .catch(e => { console.log(e); })



        var interval1 = setInterval(function () {
            number++;
            if (code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol + "//" + window.location.hostname + "/api" + "/lastData/CTInverterRelation?idSolarFarm=" + idParque + "&idCT=" + ct, { method: 'GET', credentials: 'include' })
                    .then(async (dataCT) => { setCT(await dataCT.json()); })
                    .catch(e => { console.log(e); })
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }
        }, 30000)
    }, [number, ct]);

    //Habilitar y deshabilitar botones stop y start dependiendo de si hay alguna casilla marcada.
    /*useEffect(() => {
        var htmlBotInv;
        if (listaInv === '') {
            htmlBotInv = <>
                <div className='col-auto'>
                    <a id='a-inv-command-screen-start' style={{ pointerEvents: "none", backgroundColor: "#719E71" }}>START</a>
                </div>
                <div className='col-auto'>
                    <a id='a-inv-command-screen-stop' style={{ pointerEvents: "none", backgroundColor: "#B98C8C" }}>STOP</a>
                </div>
            </>
        } else {
            htmlBotInv = <>
                <div className='col-auto'>
                    <a id='a-inv-command-screen-start' onClick={() => { setAbrirModal(true); setComandoEnviado('ON'); setEnviarDevice(deviceINV); setEnviarLista(listaInv) }}>START</a>
                </div>
                <div className='col-auto'>
                    <a id='a-inv-command-screen-stop' onClick={() => { setAbrirModal(true); setComandoEnviado('OFF'); setEnviarDevice(deviceINV); setEnviarLista(listaInv) }}>STOP</a>
                </div>
            </>
        }
        setHtmlBotonesINV(htmlBotInv);
    }, [listaInv]);*/

    // Actualizar string de la consulta a la API según qué INV están marcados
    /*const actualizarStringInv = () => {
        var str = '';

        for (let i = 0; i < CT[ct - 1].inverters.length; i++) {

            if (document.getElementById(ct + CT[ct - 1].inverters[i].idInverter).checked === true) {
                str += CT[ct - 1].inverters[i].id + ',';
            }
        }

        str = str.slice(0, -1);
        setListaInv(str)

    };*/

    useEffect(() => {

        CT.map((datoCT, index) => {
            const { idCT, nombreCT, colorCT, inverters } = datoCT;
            
            if (idCT == ct) {
                setHtmlINVS(<></>)
                childToParent(nombreCT)
                var htmlTemp = <></>
                for (let i = 0; i < inverters.length; i++) {

                    var color = inverters[i].color
                    if (inverters[i].color === "#ffffff") {
                        color = "#000000"
                    }

                    htmlTemp = <>{htmlTemp}
                        <tr className='row-table-invs-ct-screen' key={index} >
                            {/*<td className=' checkbox-ct-inv' style={{ padding: '0px', paddingTop: '0.8%' }}><input className="form-check-input" type="checkbox" id={ct + inverters[i].idInverter} onClick={() => { actualizarStringInv() }} /></td>*/}
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}><strong>{inverters[i].nameInverter}</strong></td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}><strong style={{ color: color }}>{inverters[i].status}</strong></td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}>{inverters[i].invActivePower} kW</td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}>{inverters[i].invReactivePower} var</td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}>{inverters[i].productivity}%</td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }}>{inverters[i].InvEnergyDay} kWh</td>
                            <td className='text-center td-ct-inv' onClick={() => { window.open("/#/inv/" + idCT + "/" + inverters[i].idInverter, "_self") }} style={{ color: inverters[i].colorTimestamp }}>{inverters[i].timeStamp}</td>
                        </tr>
                    </>
                }
                setHtmlINVS(htmlTemp)
            }
        })
    }, [CT])

    return (
        <div className='container-fluid' style={{ marginTop: '15px' }} key={'datosct'}>
            <div className='row'>
                {htmlBotonesINV}
            </div>
            <div className='row'>
                <div className='col-xxl-auto' id='ct-leds'>
                    <CtLEDs childToParent={childToParent} code={code} ct={ct} />
                </div>
                <div className='col' id='div-table-tab-invs-tcu'>
                    <Table className='invs-table' striped bordered hover>
                        <thead className='thead-ct-inv'>
                            <tr className='tr-ct-inv'>
                               { /*<th></th>*/}
                                <th className='text-center th-ct-inv'>Nombre</th>
                                <th className='text-center th-ct-inv'>Estado</th>
                                <th className='text-center th-ct-inv'>Pot. Activa</th>
                                <th className='text-center th-ct-inv'>Pot. Reactiva</th>
                                <th className='text-center th-ct-inv'>PR</th>
                                <th className='text-center th-ct-inv'>Energía día</th>
                                <th className='text-center th-ct-inv'>Fecha lectura</th>
                            </tr>
                        </thead>
                        <tbody className='tbody-ct-inv'>{htmlINVS}</tbody>
                    </Table>
                </div>
            </div>
          { /* <Modal centered show={abrirModal} onHide={() => setAbrirModal(false)} backdrop="static" aria-labelledby="reset_modal">
                <Modal.Header closeButton>
                    <Modal.Title>Confirmación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalConfirmacion comando={comandoEnviado} dispositivo={enviarDevice} cerrarModal={childToParentModal} ids={enviarLista} />
                </Modal.Body>
            </Modal>*/}
        </div>
    );
};

export default CtData;